import React, { useEffect, useState, useRef } from 'react'
import Loading from '../components/Loading'
import { ref, get, set, onValue, push } from 'firebase/database'
import { db } from '../..'
import { useLocation } from 'react-router-dom'
import BottomMenu from './components/BottomMenu'

const SpecialItems = () => {
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const { gameId, teamId } = location.state;
  const [specialItems, setSpecialItems] = useState([]);
  const [usingCard, setUsingCard] = useState(null);
  const [teamData, setTeamData] = useState({});
  const [disabled, setDisabled] = useState(false);
  const [limitTime, setLimitTime] = useState("");
  const [waiting, setWaiting] = useState(false);
  const limitTimeIntervalRef = useRef(null);

  useEffect(() => {
    // ゲームに登録されたアイテムのデータを取得
    get(ref(db, 'games/' + gameId + '/specialItems')).then((snapshot) => {
      if(snapshot.exists()) {
        setSpecialItems(snapshot.val());
      }
      setLoading(false);
    }).catch((error) => {
      console.error('アイテムデータの取得に失敗しました:', error);
      setLoading(false);
    });

    //チームの情報を取得
    const teamRef = ref(db, 'gameLogs/' + gameId + '/teams/' + teamId);
    const unsubscribeTeam = onValue(teamRef, (snapshot) => {
      if(snapshot.exists()) {
        setTeamData(snapshot.val());

        // アイテムの使用状態を取得
        if(snapshot.val().usingCard) {
          setDisabled(true);
          setUsingCard(snapshot.val().usingCard);

          // 残り時間を表示（既存のインターバルはクリアしてから新規作成）
          if(limitTimeIntervalRef.current) {
            clearInterval(limitTimeIntervalRef.current);
            limitTimeIntervalRef.current = null;
          }
          limitTimeIntervalRef.current = setInterval(() => {
            updateLimitTime(snapshot.val().usingCard.limit, snapshot.val().usingCard.waitingLimit);
          }, 1000);
        }
      }
    });

    return () => {
      unsubscribeTeam();
      if(limitTimeIntervalRef.current) {
        clearInterval(limitTimeIntervalRef.current);
        limitTimeIntervalRef.current = null;
      }
    };
  }, [gameId, teamId]);

  // アイテムを使用
  const buyCard = (index) => {
    if(!window.confirm('アイテムを使用しますか？')) return;

    // アイテムのスコアが足りない場合
    if(teamData.score < specialItems[index].score) {
      alert('スコアが足りません');
      return;
    }

    // チームデータを更新
    const newTeamData = { ...teamData, 
      score: Number(teamData.score) - Number(specialItems[index].score),
      usingCard: {
        ...specialItems[index],
        limit: new Date().getTime() + ((Number(specialItems[index].time) + (Number(specialItems[index].waitingTime || 0))) * 60 * 1000), // 有効時間の計算
        waitingLimit: specialItems[index].waitingTime ? (new Date().getTime() + (Number(specialItems[index].waitingTime) * 60 * 1000)) : null
      }
    };

    // アイテムの使用情報を保存
    set(ref(db, 'gameLogs/' + gameId + '/teams/' + teamId + '/usingCard'), newTeamData.usingCard)
    .then(() => {
      // チームのスコアを更新
      set(ref(db, 'gameLogs/' + gameId + '/teams/' + teamId + '/score'), newTeamData.score)
      .then(() => {
        // ゲームログに記録
        push(ref(db, 'gameLogs/' + gameId + '/history'), {
          time: new Date().toISOString(),
          team: newTeamData,
          action: "アイテムの使用",
          actionNum: 5,
          teamId: teamId,
          cardId: index,
          card: specialItems[index]
        })
        .then(() => {
          setUsingCard(specialItems[index]);
          setDisabled(true);
          window.location.reload(); // ページをリロードして最新の状態を反映
        });
      });
    })
    .catch((error) => {
      console.error('Error writing document: ', error);
      alert('エラーが発生しました。繰り返し発生する場合は、ゲーム運営者にお問い合わせください。');
    });
  }

  // アイテムの残り時間を更新
  const updateLimitTime = (limit, waitingLimit) => {
    const now = new Date().getTime();
    const diff = limit - now;
    const waitingDiff = waitingLimit ? waitingLimit - now : null;

    // 残り時間が0以下の場合、アイテムを非表示
    if(diff <= 0) {
      setUsingCard(null);
      setDisabled(false);
      setWaiting(false);
      return;
    }

    // まだ待ち時間の場合
    if(waitingDiff && waitingDiff > 0) {
      const waitingMinutes = Math.floor(waitingDiff / 60000);
      const waitingSeconds = Math.floor((waitingDiff % 60000) / 1000);
      setLimitTime(('0' + waitingMinutes).slice(-2) + ':' + ('0' + waitingSeconds).slice(-2));
      setWaiting(true);
      return;
    }

    // 有効の場合
    const minutes = Math.floor(diff / 60000);
    const seconds = Math.floor((diff % 60000) / 1000);
    setLimitTime(('0' + minutes).slice(-2) + ':' + ('0' + seconds).slice(-2));
    setWaiting(false);
  }

  return (
    <div className='max-w-6xl mx-auto my-6'>
        <Loading show={loading} text="アイテムを読込み中…" />
        <h1 className='text-2xl mb-6 mx-4 text-center'>アイテム</h1>

        <div className='md:grid md:grid-cols-2'>
          {/* 使用中のアイテムを表示 */}
          <div className='mb-8'>
            <h2 className='text-gray-500 text-lg text-center tracking-wider'>使用中</h2>
            {
              usingCard ? (
                <div className='rounded-lg bg-white shadow-lg p-4 m-3 max-w-64 min-h-72 mx-auto'>
                  <h3 className='text-2xl text-purple-700 mb-4'>{usingCard.name}</h3>
                  <p className='text-gray-600 mb-3'>{usingCard.detail}</p>

                  {waiting ? (
                    <p className='text-red-800 mb-3 text-lg text-center'><i className='bi bi-hourglass-split mx-1 text-red-600'></i>待機中</p>
                  ) : (
                    <p className='text-gray-800 mb-3 text-lg text-center'><i className='bi bi-check-circle mx-1 text-lime-600'></i>有効</p>
                  )}
                  
                  <h4 className='text-purple-800'>残り時間</h4>
                  <p className='text-3xl text-gray-800 play-regular text-center'>{limitTime}</p>
                </div>
              ) : (
                <p className='text-center text-gray-600 my-12'>使用中のアイテムはありません</p>
              )
            }
          </div>

          {/* 使用可能アイテムの一覧を表示 */}
          <div className='mb-8'>
            {/* 現在のスコア表示 */}
            <div className='rounded-lg bg-white shadow-sm p-3 m-3 mb-6 max-w-sm mx-auto'>
              <h5 className='text-base text-gray-600 text-center'><i className='bi bi-coin mx-1 text-lime-600'></i>スコア</h5>
              <div className='text-2xl text-purple-600 font-medium text-center mb-2 tracking-wider'>{teamData.score} pt</div>
            </div>

            <h2 className='text-gray-500 text-lg text-center tracking-wider'>使用可能</h2>
            <div className='grid grid-cols-2'>
              {
                specialItems.map((card, index) => (
                  <div key={index} className='relative rounded-lg bg-white shadow-sm p-4 m-3'>
                    <h3 className='text-xl text-purple-700 mb-2'>{card.name}</h3>
                    <div className='mb-2'>

                      {/* 待機時間が設定されている場合、それも表示 */}
                      <p className='text-gray-800'>
                        <i className='bi bi-hourglass-split mx-1 text-lime-600'></i>
                        {card.waitingTime ?
                          <>{card.waitingTime}<span className='text-gray-600 text-sm ms-1'>分 待つ</span></>
                          : <span className='text-gray-600 text-sm'>待ち時間なし</span>
                        }
                      </p>

                      <p className='text-gray-800'><i className='bi bi-clock mx-1 text-lime-600'></i>{card.time}<span className='text-gray-600 text-sm ms-1'>分 有効</span></p>
                      <p className='text-gray-800'><i className='bi bi-coin mx-1 text-lime-600'></i>{card.score}<span className='text-gray-600 text-sm ms-1'>pt</span></p>
                    </div>
                    <p className='text-gray-600 text-sm mb-11'>{card.detail}</p>

                    <div className='absolute bottom-3 w-full start-0'>
                      <div className='mx-3'>
                        <button onClick={() => buyCard(index)} className='w-full bg-purple-500 hover:bg-purple-600 text-white p-2 rounded-md disabled:bg-purple-300' disabled={disabled}>使用する</button>
                      </div>
                    </div>
                  </div>
                ))
              }
            </div>
          </div>
          
        </div>

        {/* 下部固定メニュー */}
        <BottomMenu gameId={gameId} teamId={teamId} />
    </div>
  )
}

export default SpecialItems